
    import $ from 'jquery'
    import { defineComponent } from 'vue';
    import { RootObject,ImageData } from '@/Classes/Interfaces';
    import CollapseComp from '@/Components/CollapseComp.vue';
    import ImageCollapse from '@/Components/ImageCollapse.vue';
    type returnType= {
        dataObj: RootObject|null;
        displayData:boolean;
    }
    export default defineComponent({
    data: function (): returnType {
        return {
            dataObj: null,
            displayData:false
        };
    },
    methods: {
        loadData: function () {
            // eslint-disable-next-line
            let self = this;
            $.getJSON("/Data/Data.json", function (data: RootObject) {
                self.dataObj = data!;
                // console.log(self.dataObj.ImageData[0].ImagePath)
                self.displayData = true;
            });
        },
        removeTag:function(ImageDataObj:ImageData,Tag:string){
            let i = this.dataObj!.ImageData.indexOf(ImageDataObj);
            let temp = this.dataObj?.ImageData[i];
            temp?.Tags.splice(temp.Tags.indexOf(Tag),1)
        },
        RemoveImageDataItme:function(ImageDataObj:ImageData){
            this.dataObj!.ImageData.splice(this.dataObj!.ImageData.indexOf(ImageDataObj),1);
        }
    },
    created: function () {
        this.loadData();
    },
    components: {CollapseComp,ImageCollapse}
})
